import { APP_TYPES } from "../apiLogic/constants";
import { prePaymentData, orderPaymentData, selfPaymentData, invPaymentData, gsPaymentData, ftoPaymentData} from "../data/data";

export default class AppData {

    static data;
    static selectedLang = 'en';
    static selectedLocaleCode = 'en_US';
    static selectedCountry = 'IE';
    static contactNumber = '';
    static selectedI18nextLang = 'en';

    static setData(appType) {
        if (appType == APP_TYPES.PRE_PAYMENT) {
            AppData.data = prePaymentData;
        } else if (appType == APP_TYPES.ORDER_PAYMENT || appType == APP_TYPES.NEW_ORDER_PAYMENT || appType == APP_TYPES.ONE_FLOW_PAYMENT) {
            AppData.data = orderPaymentData;
        } else if (appType == APP_TYPES.SELF_PAYMENT) {
            AppData.data = selfPaymentData;
        } else if (appType == APP_TYPES.FOR_TEACHERS_ONLY) {
            AppData.data = ftoPaymentData;
        } else if (appType == APP_TYPES.SIMPLY_GOLDSTAR) {
            AppData.data = gsPaymentData;
        }else {
            AppData.data = invPaymentData;
        }
    }

    static getData() {
        return AppData.data;
    }

    static isSiteActive(locale) {
        if(locale)
          return AppData.data[locale.toLowerCase()] ? true : false;
    }

    static setLangAndLocaleCode(locale) {
        if (locale) {
            locale = locale.toLowerCase();
            AppData.selectedLang = AppData.data[locale] && AppData.data[locale].lang ? AppData.data[locale].lang : 'en';
            AppData.selectedLocaleCode = AppData.data[locale] && AppData.data[locale].lang && AppData.data[locale].region ? AppData.data[locale].lang +"_"+ AppData.data[locale].region : 'en_US';
            AppData.selectedI18nextLang = AppData.data[locale] && AppData.data[locale].i18nextLang ? AppData.data[locale].i18nextLang : 'en';
            AppData.selectedCountry = AppData.data[locale] && AppData.data[locale].region ? AppData.data[locale].region : 'IE';
            AppData.contactNumber = AppData.data[locale] && AppData.data[locale].contact ? AppData.data[locale].contact : '';
            AppData.availableCards = AppData.data[locale] && AppData.data[locale].availableCards ? AppData.data[locale].availableCards : '';
        }
    }

    static getAvailableCards() {
        return AppData.availableCards;
    }
    static getLang() {
        return AppData.selectedLang;
    }
    static getI18nextLang() {
        return AppData.selectedI18nextLang;
    }
    static getLocaleCode() {
        return AppData.selectedLocaleCode;
    }
    static getSelectedCountry() {
        return AppData.selectedCountry;
    }
    static getContactNumber() {
        return AppData.contactNumber;
    }
    static getLocaleDetails(locale) {
        if(locale)
            return AppData.data[locale.toLowerCase()];
    }
    static getPaymentMethods(locale) {
        if(locale)
            return AppData.data[locale.toLowerCase()].paymentMethods;
    }
    static getCurrency(locale) {
        if(locale)
            return AppData.data[locale.toLowerCase()].currency;
    }
    static getMinPaymentAmount(locale) {
        if(locale)
            return AppData.data[locale.toLowerCase()].minPaymentAmount;
    }
    static getMaxPaymentAmount(locale) {
        if(locale)
            return AppData.data[locale.toLowerCase()].maxPaymentAmount;
    }
}